export const isZipOrPdf = (file) => {
    return (
      file.type === 'application/zip' ||
      file.type === 'application/pdf' ||
      file.type.startsWith('video/') ||
      file.type.startsWith('image/')
    );
  };
  
  export const handleConditionLogic = (currentPage, readOnly, dataCondition, title, setCondition) => {
    if (currentPage === '/publish') {
      if (readOnly || dataCondition) {
        setCondition(title === 'FileUpload');
      } else {
        setCondition(false);
      }
    } else {
      setCondition(false);
    }
  };
  
  export const syncDrawerState = ({
    drawerData,
    existingComponentIndex,
    selectedFile,
    fileValue,
    fileInputValue,
    subFileValue,
    selectedFileName,
    readOnly
  }) => {
    if (drawerData.length > 0 && drawerData[existingComponentIndex]) {
      const state = drawerData[existingComponentIndex].state;
      state.selectedFile = selectedFile;
      state.fileValue = fileValue;
      state.mainFileInputValue = fileInputValue;
      state.subFileValue = subFileValue;
      state.mainSelectedFileName = selectedFileName;
      state.readOnly = readOnly;
    }
  };
  